import "./App.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./pages/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import ArtistMain from "./pages/ArtistMain";
//import Header from "./components/Header";
import SignupForm from "./pages/Artistsignup";
import LoggedIn from "./pages/Loggedinartist";
import ArtistCalender from "./pages/artistcalender.js";
import Me from "./pages/me.js";
import ArtistProfile from "./pages/ArtistProfile";

import EventDetails from "./pages/EventDetails.js";
import EventOverview from "./pages/EventOverview.js";
import BusinessLoggedInArtist from "./pages/bussiness/BusinessLoggedinartist.js";
import QrCode from "./pages/bussiness/BusinessQr.js";
import BusinessCalendar from "./pages/bussiness/Businesscalender.js";
import BusinessProfile from "./pages/bussiness/ArtistProfile.js";
import BusinessEventDetails from "./pages/bussiness/BusinessEventDetails.js";
import { ToastContainer } from "react-toastify";
// import Waiter from "./pages/Waiter/Main.js";
// import OrderDetailsPage from "./pages/Waiter/Order.js";

function App() {
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Suppress automatic install popup
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);
  return (
    <div
      className="flex flex-col items-center justify-start w-screen bg-transparent"
      style={{ fontFamily: "manrope", height: "100dvh" }}
    >
      {/* {!shouldHideHeader && <Header />}  */}

      <div className="flex flex-1 ">
        <ToastContainer position="top-center" autoClose={3000} />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/artist" element={<ArtistMain />} />
          <Route path="/artistsignup" element={<SignupForm />} />
          <Route path="/Registerartist" element={<Login />} />
          <Route path="/loggedinartist" element={<LoggedIn />} />
          <Route path="/bookevent" element={<ArtistCalender />} />
          <Route path="/EventDetails/:id" element={<EventDetails />} />
          <Route path="/venue/:eventId/overview" element={<EventOverview />} />
          <Route path="/EventDetails/:id" element={<EventDetails />} />
          <Route
            path="/loggedinartistbussiness"
            element={<BusinessLoggedInArtist />}
          />
          <Route path="/businessQr" element={<QrCode />} />
          <Route path="/businessCalendar" element={<BusinessCalendar />} />
          <Route path="/businessProfile" element={<BusinessProfile />} />
          <Route
            path="/businessEventDetails/:id"
            element={<BusinessEventDetails />}
          />
          <Route path="/me" element={<Me />} />
          <Route path="/artistprofile" element={<ArtistProfile />} />

          {/* Add more routes as needed */}

          {/* <Route path="/Waiter" element={<Waiter />} />
          <Route path="/Waiter/orders/:orderId" element={<OrderDetailsPage />} /> */}
        </Routes>
      </div>
    </div>
  );
}

export default App;
